import styled from 'styled-components'

const flex = 'display: flex; align-items: center; justify-content: space-between;'

export const StyledHeader = styled.div`
  ${flex}

  #language-selection {
    div[role='select-value'] {
      margin-right: 0;
    }
  }

  & > button {
    padding: 0;
    background-color: transparent;
  }

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    div[role='options'] {
      left: unset;
      right: 0;
    }
  }
`

export const Logo = styled.img`
  width: auto;
  height: 1.25rem;
`

export const MobileMenuHandler = styled.div`
  @media screen and (min-width: ${props => props.theme.screens.tablet}) {
    display: none;
  }
`

export const RightSection = styled.div<{ publicPage?: boolean }>`
  position: relative;
  z-index: 3;
  ${flex};

  & > div:first-child {
    margin-right: ${props => props.theme.spacing.default};
  }

  @media screen and (max-width: ${props => props.theme.screens.tablet}) {
    display: ${props => (props.publicPage ? 'flex' : 'none')};
  }
`

export const HeaderItemWrapper = styled.div`
  div[role='select'] {
    * {
      white-space: nowrap;
    }

    & > div:first-of-type {
      border: 0;
    }
  }

  div[role='options'] {
    width: auto;

    & > button {
      div {
        display: flex;
        align-items: center;
        gap: ${props => props.theme.spacing.default};
      }
    }
  }

  svg {
    color: ${props => props.theme.colors.secondary[500]};
  }
`
